import React, { memo } from 'react'

import { number, string } from 'prop-types'

function Thumbnail({ previewUrl = undefined, alt, position = null }) {
  return (
    <span className="variations-tree__thumbnail">
      {previewUrl && <img className="variations-tree__image" src={previewUrl} alt={alt} loading="lazy" />}
      {position != null && <span className="variations-tree__position">{position}</span>}
    </span>
  )
}

Thumbnail.propTypes = {
  previewUrl: string,
  alt: string.isRequired,
  position: number,
}

export default memo(Thumbnail)
